// External Imports
import { createSelector } from 'reselect';

// Internal Imports
import { englishAlternatives, ENGLISH } from '../config/types/language.js';
import { getLocale } from './getLocale.js';

// Local Functions
const getEditionFromLocale = (locale) =>
  // See docs/in-product-locale.md
  englishAlternatives.includes(locale) ? ENGLISH : locale;

const getEdition = createSelector(getLocale, getEditionFromLocale);

// Module Exports
export { getEdition, getEditionFromLocale };
